import { Navigate, useNavigate, useParams } from "react-router-dom";
import { Markdown } from "component-library";
import { InfoPage as InfoPageData } from "@shared/praxis-config";
import { FormWrapper } from "../../components/form-wrapper";
import { usePraxis } from "../../praxis-config/praxis-context";
import { useLocalizedText } from "../../praxis-config/use-localized-text";
import { routeOfInfoPageOrSend } from "./info-page-routes";

const InfoPageContent: React.FC<{ page: InfoPageData; nextRoute: string }> = ({
  page,
  nextRoute,
}) => {
  const navigate = useNavigate();
  const title = useLocalizedText(page.title);
  const text = useLocalizedText(page.text);

  return (
    <FormWrapper onSubmit={() => navigate(nextRoute)}>
      <div className="flex flex-col gap-7 my-4">
        <span className="text-2xl font-light text-text-primary text-center">
          {title}
        </span>
        <Markdown>{text}</Markdown>
      </div>
    </FormWrapper>
  );
};

export const InfoPage: React.FC = () => {
  const { id } = useParams();
  const { config } = usePraxis();
  const index = config.infoPages.findIndex((page) => page.id === id);

  if (index === -1) {
    return <Navigate to={routeOfInfoPageOrSend(config.infoPages, 0)} replace />;
  }

  return (
    <InfoPageContent
      // Remount so the next info page starts at the top with fresh texts
      key={id}
      page={config.infoPages[index]}
      nextRoute={routeOfInfoPageOrSend(config.infoPages, index + 1)}
    />
  );
};
